import { render } from "./UpsellSettings.vue?vue&type=template&id=6a47f2de&scoped=true&ts=true"
import script from "./UpsellSettings.vue?vue&type=script&lang=ts"
export * from "./UpsellSettings.vue?vue&type=script&lang=ts"

import "./UpsellSettings.vue?vue&type=style&index=0&id=6a47f2de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a47f2de"]])

export default __exports__